import { ThemeAction, ThemeActionPayload } from './actions';

const INITIAL_STATE = {
  darkTheme: false,
  lightTheme: false,
  darkCompactTheme: false,
  lightCompactTheme: false
};

export interface ThemesState {
  darkTheme: boolean;
  lightTheme: boolean;
  darkCompactTheme: boolean;
  lightCompactTheme: boolean;
}

export const themesReducer = (
  state = INITIAL_STATE,
  { type }: { type: ThemeAction; payload: ThemeActionPayload }
): ThemesState => {
  switch (type) {
    case ThemeAction.SET_THEME_LIGHT:
      return {
        ...state,
        darkTheme: false,
        lightTheme: true,
        darkCompactTheme: false,
        lightCompactTheme: false
      };
    case ThemeAction.SET_THEME_DARK:
      return {
        ...state,
        darkTheme: true,
        lightTheme: false,
        darkCompactTheme: false,
        lightCompactTheme: false
      };
    case ThemeAction.SET_THEME_DARK_COMPACT:
      return {
        ...state,
        darkTheme: false,
        lightTheme: false,
        darkCompactTheme: true,
        lightCompactTheme: false
      };
    case ThemeAction.SET_THEME_LIGHT_COMPACT:
      return {
        ...state,
        darkTheme: false,
        lightTheme: false,
        darkCompactTheme: false,
        lightCompactTheme: true
      };
    default:
      return state;
  }
};
